import { decode } from 'html-entities';

/**
 * Removes the CDATA tag from a text.
 */
export function removeCDATAFromText(text: string) {
  return (text || '').replace('<![CDATA[', '').replace(']]>', '');
}

/**
 * Lowercases XML / HTML entities.
 */
export function lowercaseEntities(text: string) {
  return (text || '').replace(/&(.*?);/gi, (v) => v.trim().toLowerCase());
}

/**
 * Full XML and HTML decode for a text.
 */
export function decodeText(text: string) {
  let cleanText = (text || '').trim();
  cleanText = lowercaseEntities(text);
  cleanText = removeCDATAFromText(cleanText);
  cleanText = decode(cleanText, { level: 'xml' });
  cleanText = decode(cleanText, { level: 'html5' });
  return cleanText;
}
